import { useCallback } from 'react';
import { fetchUser } from './fetchUser';
import { useApi } from './useApi';

const select = (result) => result.data;

export function useUser(id) {
  const fetchCallback = useCallback(() => fetchUser({ id }), [id]);
  return useApi(fetchCallback, { select });
}
